import PropTypes from 'prop-types';
import React from 'react';
import './default.scss';

const LoadingIconDefault = ({
	ball1Color,
	ball2Color,
	ball3Color,
	ball4Color,
}) => (
	<div align="center" className="cssload-fond" id="loadingIcon">
		<div className="cssload-container-general">
			<div className="cssload-internal">
				<div
					className="cssload-ballcolor cssload-ball_1"
					style={{ backgroundColor: ball1Color }}
				/>
			</div>
			<div className="cssload-internal">
				<div
					className="cssload-ballcolor cssload-ball_2"
					style={{ backgroundColor: ball2Color }}
				/>
			</div>
			<div className="cssload-internal">
				<div
					className="cssload-ballcolor cssload-ball_3"
					style={{ backgroundColor: ball4Color }}
				/>
			</div>
			<div className="cssload-internal">
				<div
					className="cssload-ballcolor cssload-ball_4"
					style={{ backgroundColor: ball3Color }}
				/>
			</div>
		</div>
	</div>
);

LoadingIconDefault.propTypes = {
	ball1Color: PropTypes.string,
	ball2Color: PropTypes.string,
	ball3Color: PropTypes.string,
	ball4Color: PropTypes.string,
};

LoadingIconDefault.defaultProps = {
	ball1Color: 'rgb(203, 32, 37)',
	ball2Color: 'rgb(248, 179, 52)',
	ball3Color: 'rgb(0, 160, 150)',
	ball4Color: 'rgb(151, 191, 13)',
};
export default LoadingIconDefault;
